import Vue from "vue";
import Router from "vue-router";
import routes from '@/router'
Vue.use(Router);

const router = new Router({
  // mode: "history",
  base: process.env.VUE_APP_BASE,
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        return {
          x: 0,
          y: 0
        }
      }, 200)
    })
  }
});

router.beforeEach((to, from, next) => {
  next()
})

export default router